export default {
  fzjn: "服裝技能",
  fzda: "服裝檔案",
  fzpc: "服裝評測",
  djmb: "頂級面板",

  ydl: "閱讀量",
  dz: "點贊",
  sc: "收藏",
  pl: "評論",
  fx: "分享",
  fhsy: "返回首頁",
  xzjs: "選擇角色",
  fzlh: "服裝立繪",
  lhxz: "立繪下載",
  lh: "立繪",
  dt: "大圖",
  xt: "小圖",
  gscg: "故事CG",
  hgddh: "好感度動畫",
  jndh: "技能動畫",
  gjswttf: "該角色暫無天賦",
  qhszdb: "強化數值對比",
  jnql: "技能潛力",
  jn: "技能",
  sz: {
    qh: "強化",
    xh: "消耗",
    lqsj: "冷卻時間",
    jnxg: "技能效果",
    hh: "回合"
  },
  daxx: "檔案資訊",
  jsyy: "角色語音",

  cqjy: "抽取建議",
  qdfx: "強度分析",
  hjfx: "環境分析",
  zrdp: "陣容搭配",
  ckgd: "查看更多",
  xhckxp: "下滑查看XP評測",
  xppc: "XP評測",
  jsmt: "角色美圖",
  xct: "宣傳圖",
  jsda: "角色檔案",
  srht: "生日賀圖",
  ect: "二創圖",
  ssxfzzsxxpc: "三四星服裝暫無詳細評測",
  xggxfdwzbpcb: "先逛逛下方的文字版评测吧",
  xggxfdzhpcb: "先逛逛下方的綜合評測吧",
  ssxfzpc: "三四星服裝評測",
  sx: "屬性",
  dqsz: "當前數值",
  fctzjpb: "副詞條最佳配比",
  qhfz: "切換服裝",
  qhbdfz: "切換綁定服裝",
  ky: "刻印",
  jx: "覺醒",
  zcjsy: "珍藏集收益",
  fzgynlz: "服裝共用能力值",
  fzbdnlz: "服裝綁定能力值",
  hydjsj: "還原頂級數據",

  tf: "天賦",
  tfqhxg: "天賦強化效果",
  gjszwtf: "該角色暫無天賦",
  jsxx: "角色資訊",
  zjtj: "最佳推薦",
  xwtb: "下位替補",
  jnsm: "技能說明",
  jnfw: "技能範圍",
  zzjzzo: "正在加載中哦",
  zlzskqlyrbzjj: "資料暫時空缺，留言讓版主加急",
  gjsxydlhcngko: "該角色需要登錄後才能觀看哦~",
  dl: "登錄",
  gjsxsmrzhcngko: "該角色需實名認證後才能觀看哦~",
  smrz: "實名認證",
  ndsmxxwwcnrbfnrwfll: "您的實名資訊為未成年人，部分內容無法瀏覽",
  tt: "推圖",
  hjzwtjzr: "環境暫無推薦陣容",
  bhhxh: "本回合消耗",
  chjqszd: "（此環境）起始戰鬥",
  zjsysp: "增加/剩餘SP",
  xhsp: "消耗SP",
  spbjbj: "SP不加不減",
  spsywf: "SP剩餘為負",
  spszzdtzsyjnssxdds: "SP是在戰鬥途中使用技能時所需的點數",
  mhhjssfhfsojnsxyhhzsphhfbfsp: "某回合，角色釋放【恢復SP】技能時；下一回合總SP會恢復部分SP",
  mhhjsgjhjtsxyhhzsphhf1sp: "某回合，角色【攻擊或擊退】時；下一回合總SP會恢復1SP",

  qsrxydzbmc: "請輸入需要的裝備名稱",
  zyzb: "專用裝備",
  zzzb: "製作裝備",
  mszb: "魔獸裝備",
  jbnl: "基本能力",
  xxnl: "選項能力",
  zynl: "專用能力",
  zb: "裝備",
  cq: "抽取",
  gl: "概率",
  sj: "隨機",
  x: "选",
  dj: "等級",
  yb: "一般",
  gj: "高級",
  zgj: "最高級",
  cs: "傳說",
  scpzy: "收藏品增益",
  xqcl: "需求材料",
  jbnlms1: "會隨機賦予基本能力2中的一個<br/>每個選項的概率都相同",
  xxnlms1:
    "達成3/6/9時，會隨機賦予：生命力（N）/ 生命力（%）/ 攻擊力（N）/ 攻擊力（%）/ 致命率（%）/ 致命傷害（%）/ 防禦力（%）/ 魔法抵抗（%）等選填中的一個，每個選項的概率都相同",
  xxnlms2:
    "達成3/6/9時，會隨機賦予：生命力（N）/ 生命力（%）/ 攻擊力（N）/ 攻擊力（%）/ 魔法力（N）/ 魔法力（%）/ 致命率（%）/ 致命傷害（%）/ 防禦力（%）/ 魔法抵抗（%）等選填中的一個，每個選項的概率都相同",

  shengxing: "升星",
  qh: "強化",
  jt: "擊退",
  gongji: "攻擊",
  wfzd: "無法戰鬥",

  专用: "專用",
  制作: "製作",
  魔兽: "魔獸",

  武器: "選擇武器",
  盔甲: "選擇盔甲",
  头盔: "選擇頭盔",
  饰品: "選擇飾品",
  手套: "選擇手套",

  生命力: "生命力",
  攻击力: "攻擊力",
  魔法力: "魔法力",
  致命率: "致命率",
  致命伤害: "致命傷害",
  防御力: "防禦力",
  魔法抵抗: "魔法抵抗",
  火属性伤害: "火屬性傷害",
  风属性伤害: "風屬性傷害",
  水属性伤害: "水屬性傷害",
  光属性伤害: "光屬性傷害",
  暗属性伤害: "暗屬性傷害",
  火属性抵抗: "火屬性抵抗",
  风属性抵抗: "風屬性抵抗",
  水属性抵抗: "水屬性抵抗",
  属性抵抗: "屬性抵抗"
};
